import ProductMixBreakdownAllItems from "@src/components/shared-containers/ProductMixBreakdownTable";
import { CustomCardWrapper } from "./style";

const CogsProductMixBreakdownAllItems = () => {
  return (
    <CustomCardWrapper>
      <ProductMixBreakdownAllItems />
    </CustomCardWrapper>
  );
};

export default CogsProductMixBreakdownAllItems;
